/**
 * Run-report presigned-URL helpers.
 *
 * Run reports live in S3 behind short-lived presigned URLs, so a run's stored
 * `report_url` expires and the "Get fresh link" action re-presigns it via
 * GET /agents/published/{agent_id}/runs/{run_id}/report-url → { url }.
 *
 * `mockFreshReportUrl` is the deterministic stand-in the MockAgentBuilderService
 * returns for that endpoint: it derives a visibly-new URL from the run's base
 * report URL (a new short expiry + a cache-busting timestamp) so the demo and
 * the e2e suite exercise the same round-trip the real presign produces. Kept as
 * a pure function so it's unit-testable without Angular DI / a DOM.
 */
export function mockFreshReportUrl(baseUrl: string, nowSeconds: number): string {
  const sep = baseUrl.includes('?') ? '&' : '?';
  return `${baseUrl}${sep}X-Amz-Expires=900&_ts=${nowSeconds}`;
}
